const firebaseConfig = {
  apiKey: "AIzaSyASHpuoiTkA-DxwxqQS_OlFhOFBM-YEAu8",
  authDomain: "hasan-s-shop-app.firebaseapp.com",
  projectId: "hasan-s-shop-app",
  storageBucket: "hasan-s-shop-app.appspot.com",
  messagingSenderId: "811449344320",
  appId: "1:811449344320:web:f3f002a18ce4bf5f205aa5"
};

  export default firebaseConfig;